"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../helpers/time");
var uniq_1 = __importDefault(require("lodash/uniq"));
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var filter_1 = __importDefault(require("lodash/filter"));
var chunk_1 = __importDefault(require("lodash/chunk"));
var json_1 = require("../helpers/json");
var CalendarModel = /** @class */ (function () {
    function CalendarModel($rootScope, $http, APPURL, $state) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$http = $http;
        this.APPUrL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/calendar",
            UPDATE: APPURL + "/api/v1/calendar",
            CREATE: APPURL + "/api/v1/calendar",
        };
        this.data = [];
        this.agendaItems = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
        this.cacheStudentCalendarResults =
            this.cacheStudentCalendarResults.bind(this);
        this.cacheCalendarResults = this.cacheCalendarResults.bind(this);
        this.getFilterOptions = this.getFilterOptions.bind(this);
        this.getFutureEntities = this.getFutureEntities.bind(this);
        // this.processAgenda = processAgenda;
        this.getAgenda = this.getAgenda.bind(this);
        this.getAgendaData = this.getAgendaData.bind(this);
        this.setAgenda = this.setAgenda.bind(this);
        this.filterAdminCalendar = this.filterAdminCalendar.bind(this);
        this.downloadAdminCalendar = this.downloadAdminCalendar.bind(this);
        this.getInstructorCalendar = this.getInstructorCalendar.bind(this);
        this.getStudentCalendar = this.getStudentCalendar.bind(this);
        this.getAdminAgenda = this.getAdminAgenda.bind(this);
        this.getInstructorAgenda = this.getInstructorAgenda.bind(this);
        this.getInstructorTeamAgenda = this.getInstructorTeamAgenda.bind(this);
        this.getStudentAgenda = this.getStudentAgenda.bind(this);
        this.getStylingForDriveCard = this.getStylingForDriveCard.bind(this);
        this.cacheStudentCalendarResults =
            this.cacheStudentCalendarResults.bind(this);
        this.agendaData = {
            data: [],
        };
        this.processDrive = this.processDrive.bind(this);
        this.processCourse = this.processCourse.bind(this);
        this.processEvent = this.processEvent.bind(this);
        this.processRTO = this.processRTO.bind(this);
        this.agendaMethods = {
            processDrive: this.processDrive,
            processCourse: this.processCourse,
            processEvent: this.processEvent,
            processRTO: this.processRTO,
        };
    }
    /////////////////////////
    CalendarModel.prototype.getStylingForDriveCard = function (drive) {
        var styling = "drive"; // drive.typeDisplay.toLowerCase().replace(' ', '-');
        if (drive.status === "Available") {
            styling += " open-session";
        }
        if (drive.actionRequired) {
            styling += " danger";
        }
        return styling;
    };
    CalendarModel.prototype.filterAdminCalendar = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/admin", params)
            .then(this.cacheResults);
    };
    CalendarModel.prototype.downloadAdminCalendar = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/admin/export", params)
            .then(this.cacheResults);
    };
    CalendarModel.prototype.getAdminAgenda = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/admin/agenda", params)
            .then(this.cacheResults);
    };
    CalendarModel.prototype.getInstructorCalendar = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/instructor", params)
            .then(this.cacheResults);
    };
    CalendarModel.prototype.getInstructorTeamCalendar = function (params) {
        //needs to be updated with own team-cal route on backend
        return this.$http
            .post(this.URLS.FETCH + "/admin", params)
            .then(this.cacheResults);
    };
    CalendarModel.prototype.getInstructorAgenda = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/instructor/agenda", params)
            .then(this.cacheResults);
    };
    CalendarModel.prototype.getInstructorTeamAgenda = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/instructor/team-agenda", params)
            .then(this.cacheResults);
    };
    CalendarModel.prototype.getStudentCalendar = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/student", params)
            .then(this.cacheStudentCalendarResults);
    };
    CalendarModel.prototype.getStudentAgenda = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/student/agenda", params)
            .then(this.cacheResults);
    };
    CalendarModel.prototype.processDrive = function (drive) {
        drive.date = drive.drive_date;
        drive.startTime = (0, time_1.formatTimeString)(drive.start_time);
        drive.typeDisplay =
            typeof drive.type === "string" ? drive.type : drive.type.name;
        drive.type = "Drive Session";
        if (drive.private === "Y") {
            drive.typeDisplay = "Drive Hidden";
        }
        drive.timestamp = (0, time_1.getUnixTimestamp)(new Date(drive.drive_date + " " + drive.start_time));
        if (drive.location) {
            // TODO: Investigate isJson/JSON.parse, it may not be necessary
            drive.location = (0, json_1.isJson)(drive.location)
                ? JSON.parse(drive.location)
                : drive.location;
        }
        if (drive.pickuplocation &&
            drive.pickuplocation.hasOwnProperty("address")) {
            // TODO: Investigate isJson/JSON.parse, it may not be necessary
            drive.pickuplocation.address = (0, json_1.isJson)(drive.pickuplocation.address)
                ? JSON.parse(drive.pickuplocation.address)
                : drive.pickuplocation.address;
        }
        var minutes = typeof drive.session_length === "string"
            ? parseInt(drive.session_length, 10)
            : drive.session_length;
        var endTime = (0, time_1.addMinutes)((0, time_1.timeStringToDate)(drive.start_time), minutes);
        drive.endTime = endTime.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
        drive.duration = (0, time_1.formatDuration)(minutes);
        drive.actionRequired =
            drive.hasUngradedReportcards === true &&
                drive.status === "Taken" &&
                (0, time_1.dateStringToDate)(drive.date) < new Date();
        drive.styling = this.getStylingForDriveCard(drive);
        if (drive.status === "Available") {
            drive.styling += " open-session";
        }
        if (drive.actionRequired) {
            drive.styling += " danger";
        }
        return drive;
    };
    CalendarModel.prototype.toQueryString = function (obj) {
        var parts = [];
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
            }
        }
        return parts.join("&");
    };
    CalendarModel.prototype.extract = function (result) {
        return result.data;
    };
    CalendarModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    CalendarModel.prototype.cacheStudentCalendarResults = function (result) {
        this.data = this.extract(result);
        this.setAgenda(result.data);
        return this.data;
    };
    CalendarModel.prototype.cacheCalendarResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    ////////////////
    CalendarModel.prototype.getFilterOptions = function (data) {
        if (data) {
            return this.$http
                .get(this.URLS.FETCH + "/options?" + this.toQueryString(data))
                .then(this.cacheResults);
        }
        return this.$http
            .get(this.URLS.FETCH + "/options")
            .then(this.cacheResults);
    };
    CalendarModel.prototype.getFutureEntities = function (data) {
        if (data) {
            return this.$http
                .get(this.URLS.FETCH + "/future-entities?" + this.toQueryString(data))
                .then(this.cacheResults);
        }
        return this.$http
            .get(this.URLS.FETCH + "/future-entities")
            .then(this.cacheResults);
    };
    CalendarModel.prototype.processCourse = function (course) {
        course.type = "Course";
        course.typeDisplay = course.name;
        // TODO: Investigate the JSON.parse, this may not be necessary
        course.location = (0, json_1.isJson)(course.location)
            ? JSON.parse(course.location)
            : course.location;
        var courseDate = typeof course.date === "string"
            ? course.date
            : (0, time_1.toYMD)(new Date(course.date));
        course.timestamp = (0, time_1.getUnixTimestamp)(new Date(courseDate + " " + course.time));
        var minutes = parseInt(course.duration, 10); // duration is in minutes
        var endTime = (0, time_1.addMinutes)((0, time_1.timeStringToDate)(course.time), minutes);
        course.endTime = endTime.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
        course.startTime = (0, time_1.formatTimeString)(course.time);
        // TODO: This causes issues in the admin agenda probably because its being formatted somewhere else as well
        // Investigate before using this directive anywhere else
        // Duration formatting handled by time helpers
        //console.log(course.duration, minutes.asMinutes(), course.date, course.endTime);
        course.styling = "course";
        return course;
    };
    CalendarModel.prototype.processEvent = function (event) {
        event.typeDisplay = "Event";
        event.type = "Event";
        // TODO: Investigate this, the JSON.parse might not be necessary
        event.location = (0, json_1.isJson)(event.location)
            ? JSON.parse(event.location)
            : event.location;
        var eventDate = typeof event.date === "string" ? event.date : (0, time_1.toYMD)(new Date(event.date));
        event.timestamp = (0, time_1.getUnixTimestamp)(new Date(eventDate + " " + event.time));
        var minutes = parseInt(event.duration, 10); // duration is in minutes
        var endTime = (0, time_1.addMinutes)((0, time_1.timeStringToDate)(event.time), minutes);
        event.endTime = endTime.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
        event.startTime = (0, time_1.formatTimeString)(event.time);
        // Duration formatting handled by time helpers
        event.styling = "event";
        return event;
    };
    CalendarModel.prototype.processRTO = function (rto) {
        rto.typeDisplay = "RTO";
        var _start_ = (0, time_1.dateTimeStringToDate)(rto.begin);
        var _end_ = (0, time_1.dateTimeStringToDate)(rto.end);
        rto.date = (0, time_1.formatDateTime)(_start_, "MM/DD/YYYY");
        rto.timestamp = (0, time_1.getUnixTimestamp)(_start_);
        rto.styling = "rto";
        // Dont show times for full or range type RTO
        if (rto.type === "full" || rto.type === "range") {
            var s_moment = new Date(_start_);
            s_moment.setHours(23, 59, 0, 0);
            var e_moment = new Date(_end_);
            e_moment.setHours(0, 0, 0, 0);
            rto.endTime = s_moment.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
            });
            rto.startTime = e_moment.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
            });
            var durationMinutes = (0, time_1.differenceInMinutes)(s_moment, e_moment);
            rto.duration = (0, time_1.formatDuration)(Math.abs(durationMinutes));
        }
        else {
            rto.endTime = _end_.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
            });
            rto.startTime = _start_.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
            });
            var durationMinutes = (0, time_1.differenceInMinutes)(_end_, _start_);
            rto.duration = (0, time_1.formatDuration)(Math.abs(durationMinutes));
        }
        rto.type = rto._type;
        return rto;
    };
    /**
     * Process the entities from the calendar to build the agenda
     * TODO: This is in three places, should eventually be put into a directive or service or something.
     * Right now its in the admin agenda, instructor agenda, and (to some degree) the calendar directive
     * @param response
     */
    CalendarModel.prototype.processAgenda = function (response, limit) {
        if (limit === void 0) { limit = 50; }
        this.agendaItems = [];
        var _allItems = [];
        var data = response.data;
        //TODO: All of this can probably be refactored to use a more functional approach
        if (typeof data.drives !== "undefined") {
            data.drives.filter(this.agendaMethods.processDrive).forEach(function (drive) {
                _allItems.push(drive);
            });
        }
        if (typeof data.courses !== "undefined") {
            data.courses
                .filter(this.agendaMethods.processCourse)
                .forEach(function (course) {
                _allItems.push(course);
            });
        }
        if (typeof data.events !== "undefined") {
            data.events.filter(this.agendaMethods.processEvent).forEach(function (event) {
                _allItems.push(event);
            });
        }
        if (typeof data.timeoffrequests !== "undefined") {
            data.timeoffrequests
                .filter(this.agendaMethods.processRTO)
                .forEach(function (rto) {
                _allItems.push(rto);
            });
        }
        _allItems = (0, uniq_1.default)(_allItems);
        var sorted = (0, sortBy_1.default)(_allItems, function (entity) {
            return entity.timestamp;
        });
        var filtered = (0, filter_1.default)(sorted, function (item) {
            return item.timestamp > (0, time_1.getUnixTimestamp)(new Date());
        });
        this.totalAgendaItems = (0, chunk_1.default)(filtered, limit);
        this.currentAgendaIndex = 0;
        var agendaData;
        if (this.totalAgendaItems.length !== 0) {
            agendaData = this.totalAgendaItems[0];
        }
        else {
            agendaData = [];
        }
        this.agendaData = {
            data: agendaData,
            total: this.totalAgendaItems.length,
            all: this.totalAgendaItems,
            list: filtered,
        };
        return this.agendaData;
    };
    CalendarModel.prototype.getAgenda = function () {
        return this.agendaData.data;
    };
    CalendarModel.prototype.getAgendaData = function () {
        return this.agendaData;
    };
    CalendarModel.prototype.setAgenda = function (data, limit) {
        if (limit === void 0) { limit = 50; }
        this.processAgenda(data, limit);
        this.$rootScope.$broadcast("ADMIN_CALENDAR_AGENDA_UPDATED");
        this.$rootScope.$broadcast("STUDENT_CALENDAR_AGENDA_UPDATED");
        return this.agendaData;
    };
    return CalendarModel;
}());
CalendarModel.$inject = ["$rootScope", "$http", "APPURL", "$state"];
exports.default = CalendarModel;
